module.exports = __webpack_public_path__ + "images/homepage-heading-image-rectangle.svg";